export default __webpack_public_path__ + "static/media/art.2c4e8d24.gif";